
import FilterActivitiesQuery from "../../graphql/activity/filterActivities.graphql"
import Dialog from "../../base_classes/Dialog"
import { Component, Prop, Watch } from "vue-property-decorator"
import modaldialog from "./modaldialog"

@Component({
    apollo: {
        filterActivities: {
            query: FilterActivitiesQuery,
            variables() {
                const activityType = this.absence ? "ABSENCE" : "STANDALONE"
                return {
                    activityType: activityType
                }
            },
            result() {
                if (this.filterActivities && this.filterActivities.length == 0) {
                    this.$emit("hide")
                }
            }
        }
    }
})
export default class SelectActivityDialog extends Dialog {
    // "Constants"

    minSearchCharacters = 3

    filterActivities: any[] = []

    headers = [
        {
            text: "Name",
            value: "name",
            sortable: false
        }
    ]

    search = ""
    lastSearch = ""
    searchLoading = false

    get searchActivities() {
        if (!this.search || this.search.length < this.minSearchCharacters) return []
        return this.filterActivities.filter(activity => activity.name && activity.name.toLowerCase().includes(this.search.toLowerCase()))
    }

    enter() {
        if (!this.search || this.searchLoading) return
        if (this.searchActivities.length == 1) this.select(this.searchActivities[0])
    }

    get fullscreen() {
        return this.$vuetify.breakpoint.xsOnly
    }

    @Prop({ default: false })
    required!: boolean

    @Prop({ default: false })
    absence?: boolean

    select(item: any) {
        this.$emit("select", item)
        this.show = false
        if (item) this.storeSelection(item)
    }

    get loading() {
        return this.$apollo.queries.filterActivities.loading
    }

}
